(function() {
    'use strict';

    angular
        .module('app')
        .controller('explanationModalController', explanationModalController);

    function explanationModalController($uibModalInstance, loginService) {
        var vm = this;
        vm.cancel = cancel;

        loginService.getPwdConstrain().then(function(data) {
            vm.data = data.data;
        });

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
